import { useSearchParams } from 'react-router-dom';
import { Breadcrumbs } from './shared/Breadcrumbs';
import { useEffect } from 'react';
import { useTranslation } from '../i18n/I18nContext';
import './page-layout.css';

const BookTestDrivePage = () => {
  const [searchParams] = useSearchParams();
  const carInfo = searchParams.get('car');
  const { t } = useTranslation();
  const title = t('showcase.testDrive.title', 'Book your test drive');

  // Скрываем footer и voice assistant на всех разрешениях
  useEffect(() => {
    // Скрываем все элементы кроме основного контента
    const footer = document.querySelector('footer');
    const voiceButton = document.querySelector('button[class*="fixed"]');
    const voicePanel = document.querySelector(
      'div[class*="fixed"][class*="inset"]'
    );

    if (footer) footer.style.display = 'none';
    if (voiceButton) voiceButton.style.display = 'none';
    if (voicePanel) voicePanel.style.display = 'none';

    // Cleanup при размонтировании
    return () => {
      if (footer) footer.style.display = '';
      if (voiceButton) voiceButton.style.display = '';
      if (voicePanel) voicePanel.style.display = '';
    };
  }, []);

  return (
    <div className="page page--flex">
      {/* Header - с ограничением ширины */}
      <div className="page__bar">
        {/* Крошки, а не ссылка «назад»: страницу открывают и по прямой
            ссылке из переписки, где «назад» вести некуда. */}
        <Breadcrumbs
          items={[
            { label: t('showcase.nav.catalog', 'Catalog'), to: '/cars' },
            { label: title },
          ]}
        />
        <h1 className="page__bar-title">{title}</h1>
        {carInfo && (
          <p className="page__bar-lead">
            {t('showcase.testDrive.selectedCar', 'Selected car:')}{' '}
            <span className="page__accent">{carInfo}</span>
          </p>
        )}
      </div>

      {/* Iframe container - full width без ограничений */}
      <div className="page__frame">
        <iframe
          src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ0vPE7FORIrEhBAMG2reI_GUfbseNWag-RGQX3lIlzrXaDdxALk6QKUMxpasjdYZ0Yw2yKVYM3X?gv=true"
          className="page__frame-embed"
          title={t('showcase.testDrive.calendar', 'Test drive booking calendar')}
        />
      </div>
    </div>
  );
};

export default BookTestDrivePage;
